let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6AM8D")).then(() => parcelRequire('5P1rg'));